import * as React from "react";
import { DrupalDogDetailPage } from "../../dog";

export interface IDrupalWorkbookNewDogFormProps {
  setDogId: any;
  setVisible: any;
}

export const DrupalWorkbookNewDogForm: React.FunctionComponent<IDrupalWorkbookNewDogFormProps> = ({
  setVisible,
  setDogId,
}) => {
  const postSave = React.useCallback(
    (newDogId: number) => {
      setDogId(newDogId);
      setVisible(false);
    },
    [setDogId, setVisible]
  );
  return (
    <DrupalDogDetailPage
      isCreationPopUp={true}
      readonlySex={false}
      postSaveFunc={postSave}
      withoutOwner={false}
      isSportSection
    />
  );
};
